import React from "react";

// A small, consistent "Coming Soon" pill used across pricing rows, feature
// cards, and roadmap sections. Visually distinct from the green "included"
// checkmark styling so crawlers and users can tell at a glance that the
// item is a future feature, not currently available.
export default function ComingSoonBadge({ className = "", testId }) {
  return (
    <span
      className={
        "inline-flex items-center gap-1 rounded-full border border-[color:rgba(255,190,110,0.35)] bg-[color:rgba(255,190,110,0.10)] px-1.5 py-0.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-[color:rgb(255,190,110)] " +
        className
      }
      data-testid={testId || "coming-soon-badge"}
    >
      Coming Soon
    </span>
  );
}
